export default {
  editDetailsTitle: 'Editar Detalhes',
  cancel: 'Cancelar',
  save: 'Salvar',
  uploadingFile: 'Enviando',
  loadingText: 'Carregando...',
  noDataText: 'Não há documentos disponíveis para este modelo',
  uploadDocument: 'Enviar documento',
  search: 'Buscar',
  headerName: 'Nome',
  headerDetails: 'Detalhes',
  headerSize: 'Tamanho',
  headerCreated: 'Criado',
  headerActions: 'Ações',
  download: 'Baixar',
  editDetails: 'Editar Detalhes',
  delete: 'Excluir',
  warningTitle: 'Aviso',
  deleting: 'Excluindo:',
  deleteConfirmation: 'Esta ação não pode ser desfeita. Tem certeza?',
  fileEdited: 'Arquivo editado',
  deletingFile: 'Excluindo arquivo',
  fileDeleted: 'Arquivo excluído',
  uploadError: 'Erro ao enviar o arquivo. Lembre-se que os únicos tipos de arquivo permitidos são XLSX, PDF e ZIP.'
}
